import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import { useNavigate, useParams, useLocation } from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";
import RestartAlt from "@mui/icons-material/RestartAlt";
import { priceService } from "../../services/priceService";
import { SetPriceDataSore, GetPriceDataStore } from "../../store/priceListAtom";
import GeneralCustomTable from "../../helpers/GeneralCustomTable";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";

const columns = [
  {
    title: "Corporate Name",
    key: "Corporate_Name",
    dataIndex: "Corporate_Name",
    // className: "text-primary",
    sorter: (a, b) =>
      (a?.Corporate_Name ?? "").localeCompare(b?.Corporate_Name ?? ""),
    render: (record) => (
      <span className="font-bold text-primary"> {record} </span>
    ),
  },
  {
    title: "Corporate Code",
    key: "Corporate_Short_Code",
    dataIndex: "Corporate_Short_Code",
    sorter: (a, b) =>
      (a?.Corporate_Short_Code ?? "").localeCompare(
        b?.Corporate_Short_Code ?? ""
      ),
  },
  {
    title: "Contact Person",
    dataIndex: "Corporate_Contact_Person",
    sorter: (a, b) =>
      (a?.Corporate_Contact_Person ?? "").localeCompare(
        b?.Corporate_Contact_Person ?? ""
      ),
  },
  {
    title: "Email",
    dataIndex: "Corporate_Email_Address",
    sorter: (a, b) =>
      (a?.Corporate_Email_Address ?? "").localeCompare(
        b?.Corporate_Email_Address ?? ""
      ),
  },

  {
    title: "Sub fees",
    dataIndex: "subscription_fees",
    sorter: (a, b) =>
      (a?.subscription_fees ?? "") - (b?.subscription_fees ?? ""),
    render: (record) => (
      <span className="font-bold text-success">
        {" "}
        {formatCustomNumber(record)}{" "}
      </span>
    ),
  },
  {
    title: "Sub Period",
    dataIndex: "Subscription_Period",
    sorter: (a, b) =>
      (a?.Subscription_Period ?? "").localeCompare(
        b?.Subscription_Period ?? ""
      ),
  },

  {
    title: "Corporate Approval",
    dataIndex: "Corporate_Approval_Status_Name",
    sorter: (a, b) =>
      (a?.Corporate_Approval_Status_Name ?? "").localeCompare(
        b?.Corporate_Approval_Status_Name ?? ""
      ),
    render: (record) => (
      <span
        className={`${
          record === "Approved"
            ? "text-green-500"
            : record === "Inactive"
            ? "text-red-500"
            : ""
        }`}
      >
        {record}
      </span>
    ),
  },
];

function PriceListPage() {
  const getPriceDataStore = GetPriceDataStore();
  const setPriceDataStore = SetPriceDataSore();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const isMounted = useRef(false);
          const [searchText, setSearchText] = useState("");
          const [tableData, setTableData] = useState([]);
  

  useEffect(() => {
    if(getPriceDataStore?.coporate_info?.length){
      setTableData(getPriceDataStore?.coporate_info);
    }

  }, [getPriceDataStore?.coporate_info]);



  const fetchDataFromServer = () => {
    priceService.getPriceList().then((res) => {
      if (res.data?.coporate_info?.length ) {
        setPriceDataStore(res.data);
      }
    });
  };

  function handleRowClick(corp) {
    navigate(
      `/${currModuleId}/${currModuleName}/${currUserMenu}/details/${corp?.Corporate_Id}`
    );
  }

  const paginationOptions = {
    pageSize: 10,
    showSizeChanger: true,
    total: getPriceDataStore?.coporate_info.length,
  };



  const handleSearch = (text) => {
    setSearchText(text);
   
     if (text.trim() === "") {
      setTableData(getPriceDataStore?.coporate_info || []);
       return;
     }
   
     const searchTerm = text.toLowerCase();
     const filtered = (getPriceDataStore?.coporate_info || []).filter(credit =>
       Object.values(credit).some(value => 
         value?.toString().toLowerCase().includes(searchTerm)
       )
     );
     setTableData(filtered); 
   };



   const onClearInput = ()=> {
    setSearchText("");
    setTableData(getPriceDataStore?.coporate_info || []);

   }

  

  return (
    <>
      <section className="mt-1 space-y-4">
        <Tooltip title="Reload">
          <button
            onClick={() => fetchDataFromServer()}
            className="text-blue-600 hover:text-blue-800 transition-colors p-1.5 rounded-full bg-gray-200 hover:bg-gray-100 active:rotate-12 active:bg-gray-200"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="size-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
              />
            </svg>

            {/* <RestartAltIcon fontSize="medium" /> */}
          </button>
        </Tooltip>


            {/* Start of search */}
    <div className="flex justify-center">
    <div className="flex flex-col w-full md:w-1/3">
      <input
        type="text"
        placeholder="Search in table"
        value={searchText}
        onKeyDown={(e) => {
          if (e.key === 'Backspace') {
            onClearInput();
          }
        }}
        onChange={(e) => handleSearch(e.target.value)}
        className="bg-white ring-1 ring-gray-200 w-full pl-3 py-2 rounded outline-none focus:ring-blue-300"
      />
    </div>
  </div>
  {/* End of search */}




        <GeneralCustomTable
          tableHeadList={columns}
          tableDataList={tableData}
          allowCheckBox={false} // show checkBox for each row
          // setSelectedRows={selectedItems} // when checkbox is checked
          paginationOptions={paginationOptions}
          rowKey={(record) => record.Item_Id} // custom key
          handleRowClick={handleRowClick}
        />
      </section>
    </>
  );
}

export default PriceListPage;
